import { handleActions } from 'redux-actions';

import { FlightSeatMapFragment } from '@websky/graphql';
import { setSeatMap, SetSeatMapAction } from './actions';

const initialState: FlightSeatMapFragment = {
	segments: []
};

const seatMapReducer = handleActions(
	{
		[setSeatMap.toString()]: (_, { payload }: SetSeatMapAction) => payload
	},
	initialState
);

export default seatMapReducer;
